<template>
    <Navbar />
    <router-view />
    <Footer />
    <Loader v-show="loading" />
</template>

<script>
import { emitter } from '@/services/emitter.service';
import Navbar from "@/components/client/Navbar.vue";
import Footer from "@/components/client/Footer.vue";
import Loader from "@/components/Loader.vue";
export default {
    components: {
        Navbar,
        Footer,
        Loader
    },
    data() {
        return { 
            loading: false,
        };
    },
     created() {
        emitter.on("showLoader", (e) => {
            this.loading = e;
        });
    },
    mounted() {
        document.querySelectorAll("link[data-theme]").forEach(el => el.remove());

        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "/css/styles.css";
        link.dataset.theme = "true";

        document.head.appendChild(link);
    }
}
</script>